import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, HostBinding, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { isContentOutdated } from 'src/helpers/dates';

export type ArchivedBannerVariant = 'press-release' | 'content';

@Component({
  selector: 'mb-archived-banner',
  templateUrl: './archived-banner.component.html',
  styleUrls: ['./archived-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ArchivedBannerComponent {
  @Input() displayDate?: Date | string;
  // 'content' is used on event / media-special pages: generic wording and Workbench's default dark theme
  @Input() variant: ArchivedBannerVariant = 'press-release';

  // Lets the preceding heading target `mb-archived-banner.is-archived` to collapse its own
  // spacing so the gap above and below the banner stays equal - see archived-banner.component.scss.
  @HostBinding('class.is-archived')
  public get isArchived(): boolean {
    return isContentOutdated(this.displayDate);
  }
}
